import { createContext } from 'react';

/**
 * The tenant's default IANA zone (DNKADM-0478), or `null` while it loads, when the read
 * fails, or outside a `TenantZoneProvider`. `null` means "not known": the calendar zone
 * then falls through to the device.
 */
export const TenantZoneContext = createContext<string | null>(null);
